function StrDate (date, type = 0) {
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? ('0' + m) : m
  let d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  let h = date.getHours()
  h = h < 10 ? ('0' + h) : h
  let minute = date.getMinutes()
  let second = date.getSeconds()
  minute = minute < 10 ? ('0' + minute) : minute
  second = second < 10 ? ('0' + second) : second
  if (type === 0 || type === 'hhmmss') {
    return String(h) + String(minute) + String(second)
  } else {
    if (type === 1) {
      return String(y) + String(m) + String(d)
    } else {
      if (type === 3) {
        return '' + y + m + d + h + minute + second
      } else {
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
      }
    }
  }
}

function addMonth (date, num) {
  let y = date.getFullYear()
  let m = date.getMonth() + 1 + num
  m = m < 10 ? ('0' + m) : m
  return String(y) + String(m)
}

function addDay (date, num) {
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? ('0' + m) : m
  let d = date.getDate() + num
  d = d < 10 ? ('0' + d) : d
  return String(y) + String(m) + String(d)
}

function showStrDateTime (row, column, cellValue) {
  if (cellValue === '--' || !cellValue || cellValue === '合计' || cellValue === '小计') {
    return cellValue
  }
  return cellValue.slice(0, 4) + '-' + cellValue.slice(4, 6) + '-' + cellValue.slice(6, 8) + ' ' + cellValue.slice(8, 10) + ':' + cellValue.slice(10, 12) + ':' + cellValue.slice(12)
}

function showStrDate (row, column, cellValue) {
  if (cellValue === '--' || !cellValue || cellValue === '合计' || cellValue === '小计') {
    return cellValue
  }
  return cellValue.slice(0, 4) + '-' + cellValue.slice(4, 6) + '-' + cellValue.slice(6, 8)
}

function showStrTime (row, column, cellValue) {
  if (cellValue === '--' || !cellValue || cellValue === '合计' || cellValue === '小计') {
    return cellValue
  }
  return cellValue.slice(0, 2) + ':' + cellValue.slice(2, 4) + ':' + cellValue.slice(4)
}

function selectWeekDay (weekDayList, date = new Date(), expireDisable = true) {
  // weekDayList  要选择的是周几列表
  // let date = new Date()
  let year = date.getFullYear() // 年
  let month = date.getMonth() // 月
  let firstDate = new Date(year, month, 1) // 本月第一天
  let weekDay = firstDate.getDay() || 7 // 获得1号是本周的第几天（从周一开始）
  let lastDate = new Date(year, month + 1, 0)
  let end = lastDate.getTime() // 本月最后一天时间戳
  let dateList = [] // 符合条件的Date列表
  for (let weekNum of weekDayList) {
    // 选择的本月第一个周几的时间戳
    let weekStart = weekDay > weekNum ? new Date(year, month, 1 + (7 - weekDay + weekNum)).getTime() // 若1号比选择的周几大，则加上 距离下周天数+选择的周几
      : weekDay === weekNum ? firstDate.getTime() // 若刚好1号就是选择的周几
        : new Date(year, month, 1 + weekNum - weekDay).getTime() // 若1号比选择的周几小，则加上 选择的周几减去1号周几
    dateList.push(new Date(weekStart)) // 符合条件的Date列表
    weekStart = weekStart + 7 * 24 * 3600 * 1000 // 下一个周几时间戳
    while (weekStart <= end) {
      dateList.push(new Date(weekStart))
      weekStart = weekStart + 7 * 24 * 3600 * 1000 // 下一个周几时间戳
    }
  }
  let noExpirelist = []
  if (expireDisable) {
    dateList.forEach(item => {
      if (item.getTime() >= Date.now()) {
        noExpirelist.push(item)
      }
    })
  }
  return expireDisable ? noExpirelist : dateList
}

function getCurrentMonthLast (date = new Date()) {
  // let date = new Date()
  let currentMonth = date.getMonth()
  let nextMonth = ++currentMonth
  let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
  let oneDay = 1000 * 60 * 60 * 24
  let MonthEndDate = new Date(nextMonthFirstDay - oneDay)
  // console.log(MonthEndDate)
  return MonthEndDate
}

// 比较两个日期
function compareDate(start, end) {
  const startDate = new Date(start.substring(0, 4), start.substring(4, 6), start.substring(6, 8))
  const endDate = new Date(end.substring(0, 4), end.substring(4, 6), end.substring(6, 8))
  if (endDate.getTime() < startDate.getTime()) {
    return false
  }
  return true
}

export {StrDate, showStrDateTime, showStrDate, showStrTime, selectWeekDay, getCurrentMonthLast, addMonth, addDay, compareDate}



// WEBPACK FOOTER //
// ./src/util/handleDateTime.js